import type { Plugin } from '@capacitor/core';
import { registerPlugin } from '@capacitor/core';

export enum KeyboardExtensionEvent {
  TOGGLE_NEGATIVE_TAPPED = 'toggleNegativeTapped',
  ACCESSORY_DONE_TAPPED = 'accessoryDoneTapped',
}

export interface KeyboardExtensionPlugin extends Plugin {
  isPhysicalKeyboard(): Promise<{ isPhysicalKeyboard: boolean }>;
  showAccessoryBar(): Promise<void>;
  hideAccessoryBar(): Promise<void>;
}

const KeyboardExtension = registerPlugin<KeyboardExtensionPlugin>(
  'KeyboardExtensionPlugin'
);

export { KeyboardExtension };
